import { IAllCourseRes } from "../../models/allcourse.model";
import { ICourseTraineesRes } from "../../models/course/course-trainees.model";
import {
  IAnnouncementRes,
  IAnnouncementStatusRes,
  ICreateAnnouncement,
  IGetAnnouncementRes,
} from "../../models/trainee-course.model";
import { ICreateDiscussion } from "../../models/trainer-creatediscussion.model";
import { IDiscussionTopicRes } from "../../models/trainer-discussiontopic.model";
import { IGetDiscussionRes } from "../../models/trainer-getdiscussion.model";
import { IAttendanceArr} from "../../models/attendance.model";
import getService from "../getService";
import postService from "../postService";
import putService from "../putService";
import deleteService from "../deleteService";
import patchService from "../patchService";

const CONFIG_API_URL =
  process.env.REACT_APP_API_BASE_URL || "http://20.126.75.78/naptin/api/v1/";

const TRAINERCOURSES = "trainers/assigned-courses";

const GETDISCUSSIONTOPICS = "courses/";
const CREATEANNOUNCEMENT = "announcements";
const CREATEDISCUSSION = "discussion-topics/";
const DISCUSSIONREPLY = "discussions/";
const COURSETRAINERS = "course-availability/";
const GETCOURSETRAINEES = "courses/";
const GETCOURSEREVIEWS = "courses/";
//attendances/bulk-template

class TrainerCoursesService {
  async getTrainerCourses() {
    const response = await getService.get(`${CONFIG_API_URL}${TRAINERCOURSES}`);
    const res: IAllCourseRes = response.data;
    return res;
  }
  async getCourseTrainees(
    uuid: string | undefined,
    session_id: string,
    term_id: string
  ) {
    const response = await getService.get(
      `${CONFIG_API_URL}${GETCOURSETRAINEES}${uuid}/trainees/${session_id}/${term_id}`
    );
    const res: ICourseTraineesRes = response.data;
    return res;
  }

  async createNewDiscussion(data: any, uuid: string) {
    const response = await postService.post(
      `${CONFIG_API_URL}${CREATEDISCUSSION}${uuid}/discussions`,
      data
    );
    return response.data;
  }
  async uploadAttendance(data: any) {
    const response = await postService.post(
      `${CONFIG_API_URL}attendances/bulk-template`,
      data
    );
    return response.data;
  }

  async getAttendances(course_id: number) {
    const response: any = await getService.get(
      `${CONFIG_API_URL}attendances?course_id=${course_id}`
    );

    const res: IAttendanceArr = response.data.data.data;
    
    return res;
  }

  async createDiscussionGroup(data: ICreateDiscussion, uuid: string) {
    const response = await postService.post(
      `${CONFIG_API_URL}${GETDISCUSSIONTOPICS}${uuid}/discussion-topics`,
      data
    );
    return response.data;
  }

  async editDiscussionGroup(
    data: { title: string; description?: string },
    uuid: string
  ) {
    const response = await putService.put(
      `${CONFIG_API_URL}discussion-topics/${uuid}`,
      data
    );
    return response.data;
  }

  async deleteDiscussionGroup(uuid: string) {
    const response = await deleteService.delete(
      `${CONFIG_API_URL}discussion-topics/${uuid}`
    );
    return response.data;
  }

  async getDiscussionGroup(data: ICreateDiscussion, uuid: string) {
    const response = await postService.post(
      `${CONFIG_API_URL}${GETDISCUSSIONTOPICS}${uuid}/discussion-topics`,
      data
    );
    return response.data;
  }

  async getDiscussionTopics(uuid: string) {
    const response = await getService.get(
      `${CONFIG_API_URL}${GETDISCUSSIONTOPICS}${uuid}/discussion-topics`
    );
    const res: IDiscussionTopicRes = response.data;
    return res;
  }

  async getDiscussionTopic(uuid: string) {
    const response = await getService.get(
      `${CONFIG_API_URL}${CREATEDISCUSSION}${uuid}`
    );
    const res: IGetDiscussionRes = response.data;
    return res;
  }

  async getDiscussion(uuid: string) {
    const response = await getService.get(
      `${CONFIG_API_URL}${CREATEDISCUSSION}${uuid}/discussions`
    );
    const res: IGetDiscussionRes = response.data;
    return res;
  }

  async replyDiscussion(data: any, uuid: string) {
    const response = await postService.post(
      `${CONFIG_API_URL}${DISCUSSIONREPLY}${uuid}/replies`,
      data
    );
    if (response.data.token && response.data.user) {
    }
    return response.data;
  }

  async getDiscussionReply(uuid: string) {
    const response = await getService.get(
      `${CONFIG_API_URL}${DISCUSSIONREPLY}${uuid}/replies`
    );
    const res: any = response.data;
    return res;
  }

  async createAnnouncement(data: ICreateAnnouncement) {
    const response = await postService.post(
      `${CONFIG_API_URL}${CREATEANNOUNCEMENT}`,
      data
    );
    if (response.data.token && response.data.user) {
    }
    return response.data;
  }

  async getCourseTrainers(uuid: string | undefined) {
    const response = await getService.get(
      `${CONFIG_API_URL}${COURSETRAINERS}${uuid}/trainers`
    );
    const res: any = response.data;
    return res;
  }
  async removeCourseTrainer(uuid: string | undefined, data: any) {
    const response = await patchService.patch(
      `${CONFIG_API_URL}${COURSETRAINERS}${uuid}/trainers`,
      data
    );
    const res: any = response.data;
    return res;
  }

  async getCourseReviews(uuid: string | undefined) {
    const response = await getService.get(
      `${CONFIG_API_URL}${GETCOURSEREVIEWS}${uuid}/reviews`
    );
    const res: any = response.data;
    return res;
  }

  async getCourseAnnouncement(uuid: string) {
    const response = await getService.get(
      `${CONFIG_API_URL}${GETDISCUSSIONTOPICS}${uuid}/announcements`
    );
    const res: IGetAnnouncementRes = response.data;
    return res;
  }

  async getSingleAnnouncement(uuid: string) {
    const response = await getService.get(
      `${CONFIG_API_URL}${CREATEANNOUNCEMENT}/${uuid}`
    );
    const res: IGetAnnouncementRes = response.data;
    return res;
  }

  async getAnnouncementStatus(uuid: string) {
    const response = await getService.get(
      `${CONFIG_API_URL}${CREATEANNOUNCEMENT}/${uuid}/mark`
    );
    const res: IAnnouncementStatusRes = response.data;
    return res;
  }

  async uploadProgramResults(data: any, uuid: string) {
    const response = await postService.post(
      `${CONFIG_API_URL}program-courses/${uuid}/upload-results`,
      data
    );
    return response.data;
  }

  // changed from put to post
  async updateProgramResults(data: any, uuid: string | number) {
    const response = await postService.post(
      `${CONFIG_API_URL}courses/${uuid}/update-results`,
      data
    );
    return response.data;
  }

  async uploadCourseResults(data: any, uuid: string) {
    const response = await postService.post(
      `${CONFIG_API_URL}courses/${uuid}/results`,
      data
    );
    return response.data;
  }

  async getUploadedResults() {
    const response = await getService.get(
      `${CONFIG_API_URL}trainers/results`
    );
    return response.data.data.result;
  }
}

export default new TrainerCoursesService();
